<template>
	<app-title-bar :icon="['fas', 'fa-map-marker']" subtitle="Stock Tools" title="Stock Checker" />

	<div class="grid grid-cols-4 gap-4">
		<div class="col-span-1">
			<app-panel title="Contract Details">
				<contract-picker
					:contract="contract"
					@update:contract="updateContract"></contract-picker>
				<template #header>
					<app-button v-if="contract" @click="contract = null">Clear</app-button>
				</template>
			</app-panel>
		</div>
		<div class="col-span-3">
			<app-panel title="Stock">
				<stock-list
					v-if="contract"
					ref="stockListRef"
					:items="contractItems"
					:contract="contract"
					@shortage-request="openShortageForm"></stock-list>
				<span v-else>Please enter a contract number</span>
			</app-panel>
		</div>
	</div>

	<!-- Stock Shortage Form Modal -->
	<stock-shortage-form
		v-if="showShortageForm"
		:contract="contract"
		:items="contractItems"
		:depots="depots"
		:stock="stockData"
		@close="closeShortageForm"
		@submitted="onShortageSubmitted"></stock-shortage-form>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import ContractService from '@/services/contract'
	import StockList from '@/components/partials/stock/StockList.vue'
	import ContractPicker from '@/components/partials/stock/ContractPicker.vue'
	import StockShortageForm from '@/components/partials/stock/StockShortageForm.vue'
	import type { Contract } from '@/data/schema/contract'
	import useToaster from '@/stores/toaster'

	const contractApi = new ContractService()

	const contractItems = ref([])
	const contract = ref<Contract>()
	const showShortageForm = ref(false)
	const depots = ref([])
	const stockData = ref([])
	const stockListRef = ref()

	const toaster = useToaster()

	const updateContract = (value) => {
		contract.value = value

		contractApi
			.getItems(value.contract_number, { withKitComponents: true, per_page: 1000 })
			.then((res) => {
				contractItems.value = res.data.data
			})
			.catch((error) => {
				toaster.error({ text: 'An error occurred retrieving the items on the contract' })
				console.log('An error occurred retrieving the items on the contract', error)
			})
	}

	const openShortageForm = () => {
		console.log('openShortageForm called')
		console.log('stockListRef.value:', stockListRef.value)
		if (stockListRef.value) {
			// Check if data is still loading
			if (stockListRef.value.loading) {
				toaster.error({ text: 'Please wait for depot data to finish loading' })
				return
			}
			
			// Get data from StockList component
			depots.value = stockListRef.value.depots || []
			stockData.value = stockListRef.value.stock || []
			console.log('depots from StockList:', depots.value)
			console.log('stockData from StockList:', stockData.value)
			console.log('depots length:', depots.value.length)
			console.log('stockData length:', stockData.value.length)
		} else {
			console.log('stockListRef.value is null/undefined!')
		}
		showShortageForm.value = true
		console.log('showShortageForm set to:', showShortageForm.value)
	}

	const closeShortageForm = () => {
		showShortageForm.value = false
	}

	const onShortageSubmitted = (request) => {
		console.log('Stock shortage request submitted:', request)
		// You can add any additional logic here, like refreshing data
		closeShortageForm()
	}
</script>
